import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from '@angular/common';

@Pipe({
	name: 'currency',
	standalone: false
})
export class CurrencyPipe implements PipeTransform {
	transform(
		value: number,
		currencyCode: string = 'USD',
		display: 'code' | 'symbol' | 'symbol-narrow' | boolean = 'symbol',
		digitsInfo: string = '1.0-0',
		locale: string = 'en-US',
	): string | null {
		let displayFormat: string;
		if (typeof display === 'boolean') {
			displayFormat = display ? 'symbol-narrow' : 'code';
		} else {
			displayFormat = display;
		}

		return formatCurrency(
			value,
			locale,
			displayFormat,
			currencyCode,
			digitsInfo);
	}
}
